import React, { useMemo } from 'react';
import { Box, Button, Divider, Flex, Image, Text, Tooltip } from '@chakra-ui/react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { LanguageChange } from '../LanguageChange/languageChange';
import { Link } from 'react-router-dom';
import { WalletElement } from '../WalletElement/walletElement';
import { t } from 'i18next';
import { useMarketProvider } from '../../providers/Market/marketProvider';
import { containerMaxWXl } from '../ContentContainer/contentContainer';
import { createStandaloneToast } from '@chakra-ui/react';
import { handleOsInstall, isLauncher } from '../../utils/launcher';
import useCustomTokens, { USDCToken } from '../../providers/Token/useCustomTokens';
import { trimAddress } from '../../utils/parser';
import Vendor from '../../vendor.config';
import { Color } from '../../theme/color';
import { ClipboardIcon } from '../../common/components/icons/clipboard';
import { WalletWhiteIcon } from '../../common/components/icons/wallet_white';
import { HamburgerRedIcon } from '../../common/components/icons/hamburger_red';

export const HeaderMinibar = ({ onOpenMobileMenu, mainColor }: any) => {
	const { playersCount, price, marketCap } = useMarketProvider();
	const { toast } = createStandaloneToast();
	const { addCustomToken } = useCustomTokens();

	const handleInstallLauncher = () => {
		handleOsInstall();
		toast({ title: 'Downloading HashUp Launcher…' });
	};

	const HeaderLeftElements = ({
		text,
		value,
		src,
		contentColor,
		contentWeight,
		isCopyContent,
		isTrimmedContent,
		secondaryAction,
	}: {
		isTrimmedContent?: boolean;
		text: string;
		value: string;
		src?: string;
		contentColor?: string;
		contentWeight?: string;
		isCopyContent?: boolean;
		secondaryAction?: { content: React.ReactNode; callback: () => void; isHidden?: boolean };
	}) =>
		useMemo(
			() => (
				<Flex
					fontWeight="600"
					alignItems="center"
					flexWrap={{ base: 'wrap', md: 'nowrap' }}
				>
					<Text>{text}: </Text>
					{src && (
						<Image
							ml="6px"
							maxW="14px"
							maxH="14px"
							src={src}
						/>
					)}
					<Text
						color={contentColor || mainColor ? mainColor : Color.ACTION}
						fontWeight={contentWeight || '600'}
						ml="6px"
					>
						{isTrimmedContent ? trimAddress(value) : value}
					</Text>
					{isCopyContent && (
						<Flex
							ml="6px"
							maxW="14px"
							maxH="14px"
							cursor="pointer"
						>
							<CopyToClipboard text={value}>
								<ClipboardIcon />
							</CopyToClipboard>
						</Flex>
					)}
					{secondaryAction && !secondaryAction.isHidden && (
						<Button
							onClick={secondaryAction.callback}
							outline="none"
							variant="unstyled"
							minWidth="auto"
							height="auto"
							ml="6px"
						>
							{secondaryAction.content}
						</Button>
					)}
				</Flex>
			),
			[text, value]
		);

	return (
		<Flex
			alignItems="center"
			justifyContent="space-between"
			gridGap="28px"
			py={{ base: '18px', hashup: '7px' }}
			px={{ base: '16px', hashup: '32px', xl: `calc((100% - ${containerMaxWXl}) / 2)` }}
			borderBottom={{ base: 'none', hashup: '1px solid #F1F3F61A' }}
			fontSize="12px"
			lineHeight="15px"
		>
			<Flex
				display={{ base: 'none', hashup: 'flex' }}
				gridGap="28px"
			>
				{HeaderLeftElements({ text: t('mainHeader.gameCounter').toString(), value: `${playersCount}` })}
				{HeaderLeftElements({ text: t('mainHeader.price').toString(), value: `$${price}` })}
				{HeaderLeftElements({ text: t('mainHeader.marketCapitalization').toString(), value: marketCap })}
				<Divider
					orientation="vertical"
					borderColor={Color.ACTION}
					height="auto"
					opacity="1"
				/>
				<Flex gridGap="8px">
					<Tooltip label="Install the HashUp Launcher">
						<Button
							color="text"
							variant="unstyled"
							height="auto"
							fontSize="10px"
							textTransform="uppercase"
							background={Vendor.gui.theme === 'light' ? 'transparent' : '#4A4949'}
							borderRadius="4px"
							padding="1px 8px"
							onClick={handleInstallLauncher}
							display={isLauncher() ? 'none' : 'flex'}
						>
							Install Launcher
						</Button>
					</Tooltip>
					<Tooltip label="Add USDC to Metamask">
						<Button
							color="text"
							variant="unstyled"
							height="auto"
							fontSize="10px"
							textTransform="uppercase"
							background={Vendor.gui.theme === 'light' ? 'transparent' : '#4A4949'}
							borderRadius="4px"
							padding="1px 8px"
							onClick={() => void addCustomToken(USDCToken)}
						>
							Add Usdc to Metamask
						</Button>
					</Tooltip>
				</Flex>
			</Flex>
			<Flex display={{ base: 'none', hashup: 'flex' }}>
				<LanguageChange />
				{/* <Divider orientation="vertical" bg={mainColor ? mainColor : colors.main_} /> */}
			</Flex>
			<Flex display={{ base: 'flex', hashup: 'none' }}>
				<Box
					cursor="pointer"
					onClick={onOpenMobileMenu}
				>
					<HamburgerRedIcon />
				</Box>
			</Flex>
			<Flex
				cursor="pointer"
				display={{ base: 'flex', hashup: 'none' }}
			>
				<Link to="/">
					<Image
						w="200px"
						src={Vendor.gui.asset.logo}
					/>
				</Link>
			</Flex>
			<Flex display={{ base: 'flex', hashup: 'none' }}>
				<WalletElement
					t={t}
					isMobile
				/>
			</Flex>
		</Flex>
	);
};
